module.exports = __webpack_public_path__ + "img/small-2.23e70234.webp";